import(/* webpackMode: "eager" */ "/app/src/app/(auth)/login/[[...mobileNumber]]/page.tsx");
